import { render } from "./NODRItoolsComponent.vue?vue&type=template&id=15e886e4"
import script from "./NODRItoolsComponent.vue?vue&type=script&lang=js"
export * from "./NODRItoolsComponent.vue?vue&type=script&lang=js"

import "./NODRItoolsComponent.vue?vue&type=style&index=0&id=15e886e4&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__